import { WEBGL } from 'three/examples/jsm/WebGL';
import { COLOR_DEFAULT_CLEAR_BG } from '../../../constants/colors';
import {
    SIZE_OPTIONS, SIZE_REFS_MAP, UNIT
} from '../../../constants/size';

const THREE = require('three');

const prepareRenderer = (w, h, transparent = false, logDepthBuf = false, antialias = false) => {
    if (!WEBGL.isWebGLAvailable()) return null;

    const renderer = new THREE.WebGL1Renderer({
        alpha: transparent,
        antialias,
        logarithmicDepthBuffer: logDepthBuf
    });

    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(w, h);
    renderer.setClearColor(COLOR_DEFAULT_CLEAR_BG, transparent ? 0 : 1);

    return renderer;
};

const prepareCamera = (params) => {
    /*
     fov — Camera frustum vertical field of view.
     aspect — Camera frustum aspect ratio.
     near — Camera frustum near plane.
     far — Camera frustum far plane.
    * */

    const defaults = {
        fov: 35,
        aspect: 1,
        near: 1,
        far: 2500
    };

    params = params || {};

    const config = { ...defaults, ...params };

    return new THREE.PerspectiveCamera(config.fov, config.aspect, config.near, config.far);
};

class SceneInfrastructure {
    constructor(renderer, camParams, w, h, clear, transparent, logDepthBuf, antialias) {
        this.renderer = renderer || prepareRenderer(w, h, transparent, logDepthBuf, antialias);

        if (!this.renderer) {

            return;
        }

        this.scene = new THREE.Scene();
        this.camera = prepareCamera(camParams);

        this.clear = clear;
    }

    render() {
        if (!this.renderer) {
            console.warn('There is no renderer initialised');
        }

        this.renderer.autoClearColor = this.clear;
        this.renderer.render(this.scene, this.camera);
        this.renderer.autoClearColor = true;
    }

    getViewSize(depth = 0) {
        const fovInRadians = (this.camera.fov * Math.PI) / 180;

        const { camDistance } = UNIT;
        const height = Math.abs(
            (camDistance - depth) * Math.tan(fovInRadians / 2) * 2
        );

        return { width: height * this.camera.aspect, height };
    }

    getPixelRatio() {
        if (!this.renderer) {
            console.warn('There is no renderer initialised');

            return 1;
        }

        return this.renderer.getPixelRatio();
    }

    getTextScale(sourceViewHeight, targetPixelHeight) {
        if (!this.camera) return 1;

        const viewSize = this.getViewSize();

        const refSize = this.camera.aspect > 1 ? SIZE_REFS_MAP[SIZE_OPTIONS.LANDSCAPE] : SIZE_REFS_MAP[SIZE_OPTIONS.PORTRAIT];
        const sourcePixelsSize = (sourceViewHeight / viewSize.width) * refSize.w;

        return targetPixelHeight / sourcePixelsSize;
    }
}

export const prepareInfrastructure = (
    renderer, camParams, w, h, clear, transparent, logDepthBuf, antialias
) => new SceneInfrastructure(
    renderer, camParams, w, h, clear, transparent, logDepthBuf, antialias
);
